import axios from "axios";

export const baseURL = "http://194.163.177.166:3000";
export const cableBaseURL = "ws://194.163.177.166:3000/cable";
export const isValidNumber = /^[0-9]+$/i;
export const isValidNumberWithForwardSlash = /^[0-9/]+$/i;

axios.defaults.baseURL = baseURL;
